import { createSelector } from "reselect";
import { getEntryByFormAndId } from "./entries";

export const isEntryValidByFormAndEntryId = createSelector(
  getEntryByFormAndId,
  (entry) => entry && entry.valid
);
